function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4219 4.34243C11.4219 4.45269 11.1108 6.69445 10.1775 7.6132C11.4219 2.10526 6.75523 1 6.75523 1C6.75523 1 7.47079 3.75443 6.44412 5.07744C6.3819 3.57068 5.66634 2.65193 5.66634 2.65193C5.13745 5.37144 3.33301 7.72346 3.33301 9.48746C3.33301 12.5378 5.41745 15 7.99967 15C10.5819 15 12.3552 12.7895 12.6663 9.48746C12.6663 7.28245 12.6663 5.78947 11.4219 4.34243Z",
  fill: "#2D67D8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.55523 11.4474C9.55523 12.4053 8.87079 13.1579 7.99967 13.1579C7.12856 13.1579 6.44412 12.4053 6.44412 11.4474C6.44412 10.4895 7.99967 7.17108 7.99967 7.17108C7.99967 7.17108 9.55523 10.4895 9.55523 11.4474Z",
  fill: "white"
});

function SvgGasMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasMeter);
export default __webpack_public_path__ + "static/media/gas-meter.a54b1aa3.svg";
export { ForwardRef as ReactComponent };